var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center cursor-pointer w-fit",on:{"click":_vm.menuopen}},[_c('p',{staticClass:"text-skin-blue"},[_vm._v("Filtrar Cursos")]),_c('ChevronDown',{attrs:{"color":"#F28062"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }